// Compact meetup metadata card. Sits above the Net forecast tile when the
// event is a meetup, exposing edition / time / capacity / talks. Other
// shared fields (name, location, date, currency, VAT) stay in the TopBar.

import type { EventMeta, MeetupMeta } from '../lib/types';

type Props = {
  meta: EventMeta;
  onChange: (patch: Partial<EventMeta>) => void;
};

export default function MeetupDetailsCard({ meta, onChange }: Props) {
  const m: MeetupMeta = meta.meetup_meta ?? {};

  function setMeetup(p: Partial<MeetupMeta>) {
    onChange({ meetup_meta: { ...m, ...p } });
  }

  return (
    <div className="card meetup-details-card">
      <div className="section-head">
        <h2>Meetup details</h2>
        <span className="muted">Lighter template · one evening</span>
      </div>
      <div className="meetup-details-grid">
        <div className="field">
          <label>Edition (#)</label>
          <input
            className="input"
            type="number"
            min={0}
            value={m.number ?? ''}
            onChange={(e) =>
              setMeetup({
                number: e.target.value === '' ? undefined : Number(e.target.value),
              })
            }
          />
        </div>
        <div className="field">
          <label>Start time</label>
          <input
            className="input"
            type="time"
            value={m.hour ?? ''}
            onChange={(e) => setMeetup({ hour: e.target.value || undefined })}
          />
        </div>
        <div className="field">
          <label>Max participants</label>
          <input
            className="input"
            type="number"
            min={0}
            value={m.max_participants ?? ''}
            onChange={(e) =>
              setMeetup({
                max_participants:
                  e.target.value === '' ? undefined : Number(e.target.value),
              })
            }
          />
        </div>
        <div className="field">
          <label>Talks / speakers</label>
          <input
            className="input"
            type="number"
            min={0}
            value={m.talk_count ?? ''}
            onChange={(e) =>
              setMeetup({
                talk_count: e.target.value === '' ? undefined : Number(e.target.value),
              })
            }
          />
        </div>
      </div>
    </div>
  );
}
